export const environment = {
  production: true,
  runmode: '',
  apiEndpoint: '/tdh-api',
  documentEndpoint: '/dm-api/dm',
  adfsEndpoint: '/tdh-api/login-with-adfs',
  reportApiEndpoint: '/report',
  documentManagementEndpoint: '/drive',
  consentEndpoint: 'https://consent.thailandpost.co.th',
  consentDataId: '42ad4bcc-4199-4ed9-ae4b-fced8a04e5a0',
  consentDataWorkspaceId: '7058dda7-e29b-40d3-ba98-0824fc79721a',
  consentDsrmDataId : '68ac94f5-dcbd-4742-8b16-68cba97b5a60',  
  cookieEndpoint: 'https://cookies.thailandpost.co.th',
  cookieDataId: '6419aefbb7b039c2fd4b153e',
  printAndPostEndpoint: '/printandpost',
  printAndPostUrlEndpoint: 'https://tdh.promptpostdemo.com/printandpost',
  postfixEmail:'@promptpost.com',
  identityProviderType: 'TDH',
  digitalMailboxURL: 'https://mail.promptpostdemo.com',
  helpdeskEndpoint: '/helpdesk/home',
  helpdeskQueryParams: '?goto=openticket',
  publicRelationEndpoint: '/publicrelation/landing',
  reportDigitalMailboxUrl: 'https://mail.promptpostdemo.com',
  reportPublicRelationUrl: 'https://analytics.google.com/analytics/web/provision/?authuser=0#/',
  urlKtbEndpoint : 'https://uatktbfastpay.ktb.co.th/SIT/eng/payment/payForm.jsp',
  apiTimeout: 10000,
  apiDigitalMailboxTimeout: 60000,
  apiRetry: 2,
  timezone: 'Asia/Bangkok',
  permissionCode: {
    CREATE_USER_ADMIN: 'CREATE_USER_ADMIN',
    CREATE_ADMIN: 'CREATE_ADMIN',
    CREATE_SYSTEM_ADMIN: 'CREATE_SYSTEM_ADMIN',
    CREATE_USER: 'CREATE_USER',
  },
  group: {
    ADMIN: 'OFFICER ADMIN',
    USER_ADMIN: 'USER ADMIN',
    SYSTEM_ADMIN: 'SYSTEM ADMIN',
    USER: 'USER',
  },
  application: {
    name: 'บริษัท ไปรษณีย์ไทย จำกัด (ปณท) (Thailand Post)',
    headerMainName: 'Thailand Post',
    headerSubName: 'Prompt Post',
    licenceName: '2022 บริษัท ไปรษณีย์ไทย จำกัด (ปณท) (Thailand Post)',
    icon: '',
    version: '1.0.0',
    by: 'Thailand Post',
    homePage: '/dashboard',
  },
  defaultLanguage: 'TH',
  exportLimit: 10000,
  mailMaxFileSize: 10000000,
  keyCode: {
    Tab: 9,
    Enter: 13,
    Esc: 27,
    Space: 32,
    ArrowUp: 38,
    ArrowDown: 40,
    Backspace: 8
  },
  tutorialUrl : 'https://tdh.promptpost.com/drive/#/public/sharing/prMTLS9kQWaFG8Man37c3Q'
};
